<template>
  <v-container>

    <h2>{{ club.club_name }} ({{ club.club_shortcut }})</h2>
    <div class="my-2" v-if="club.club_type === 'CLUB'"><b>Předseda oddílu:</b> <span v-if="club.predseda"><router-link :to="'/ucet/' + club.predseda">{{ club.predseda_name }}</router-link></span> <span v-else>není zadaný</span>  </div>
    <div class="my-1"><b>Počet členů:</b> {{ members.length }}</div>




    <v-tabs
      v-model="tabs"
      bg-color="primary"
      slider-color="#F1A829"
      grow
      center-active
      show-arrows
      density="comfortable"
    >
      <v-tab value="members">Členové</v-tab>
      <v-tab value="club_payments_rules" v-if="isUserClub">Pravidla financování</v-tab>
      <v-tab value="club_payments" v-if="isClubManager">Účetnictví</v-tab>
      <v-tab value="automodules" v-if="isClubManager">Správa automodulů</v-tab>
      <v-tab value="about" v-if="club.club_type === 'CLUB'">O oddíle</v-tab>

    </v-tabs>

    <v-tabs-window v-model="tabs">
      <v-tabs-window-item
        value="members"
      >
      <component
        :is="club.club_type === 'CLUB' ? ClubPageMembersTable : ClubPageMembersTableRepre"
        :members="members"
        :club="club"
        :assistUser="assistUser"
        :isClubManager="isClubManager"
        :hasOrganizerData="hasOrganizerData"
        :hasClubManagerData="hasClubManagerData"
        :loading="loading"
        @fetchMembers="fetchMembers"
      />
      </v-tabs-window-item>

      <v-tabs-window-item value="club_payments_rules">

        <ClubPagePaymentsRules
          :active-tab="tabs"
          :isClubManager="isClubManager"
        />

      </v-tabs-window-item>



      <v-tabs-window-item value="club_payments">
        <ClubPagePayments 
        :active-tab="tabs"
        />
      </v-tabs-window-item>

      <v-tabs-window-item value="automodules">
        <ClubPageAutomodules
        :active-tab="tabs"
        />
      </v-tabs-window-item>

      <v-tabs-window-item value="about">
        <ClubPageAboutClub
        :club="club"
        :isClubManager="isClubManager"
        @fetchClub="fetchClub"
      />
      </v-tabs-window-item>


    </v-tabs-window>

  </v-container>
</template>

<script setup>
import { ref, computed, watch } from 'vue';
import { useRoute } from 'vue-router';
import apiClient from '/api.js';
import { useAuthStore } from '/auth.js';
import ClubPageMembersTable from '@/components/ClubPageMembersTable.vue';
import ClubPageMembersTableRepre from '@/components/ClubPageMembersTableRepre.vue';
import ClubPageAboutClub from '@/components/ClubPageAboutClub.vue';
import ClubPagePayments from '@/components/ClubPagePayments.vue';
import ClubPagePaymentsRules from '@/components/ClubPagePaymentsRules.vue';
import ClubPageAutomodules from '@/components/ClubPageAutomodules.vue';
// import {useSnackbarStore} from '@/stores/snackbarStore'

// const snackbar = useSnackbarStore()
const authStore = useAuthStore();
const loading = ref(true); 

const route = useRoute();
const clubShortcut = ref(route.params.id); // Získání ID oddílu z URL


const members = ref([]);
const club = ref({ club_name: '', club_shortcut: '', id: null, predseda: null, predseda_name: '' });

// pro zobrazení oprávnění v tabulce
const hasOrganizerData = ref(false);
const hasClubManagerData = ref(false);

const fetchClub = async () => {
  try {
    const response = await apiClient.get(`club/?club_shortcut=${clubShortcut.value}`);
      club.value = response.data;
  } catch (error) {
    console.error('Error fetching club details:', error);
  }
};

// Oprávnění
const clubId = computed(() => Number(club.value.id));
const isClubManager = computed(() =>
  authStore.isClubManager(clubId.value)
);
const isUserClub = computed(() =>
  authStore.rolesByIndex.some(entry =>
    entry.club === clubId.value
  )
);


const fetchMembers = async () => {
  try {
    loading.value = true;
    const response = await apiClient.get(`members/?club_shortcut=${clubShortcut.value}`);
    members.value = response.data;
    hasOrganizerData.value = response.data.some(member => member.is_organizer !== undefined);
    hasClubManagerData.value = response.data.some(member => member.is_club_manager !== undefined);
  } catch (error) {
    console.error('Error fetching members:', error);
  } finally {
    loading.value = false;  // Nastavíme loading na false po načtení dat
  }
};

const assistUser = ref([]);

const fetchAssistUser = async () => {
  try {
    const response = await apiClient.get('account/?list=true');
    assistUser.value = response.data; // Naplnění dat do seznamu
  } catch (error) {
    console.error('Chyba při načítání účtů:', error);
  }
};


const tabs = ref('members'); // Výchozí záložka


// Sledujeme změny v parametru ID a reagujeme na ně
watch(() => route.params.id, (newId) => {
  clubShortcut.value = newId; // Aktualizace ref pro clubId
  tabs.value = 'members'; // při zěmně oddílu se záložka přepne na prní
  fetchClub();
  fetchMembers();
  fetchAssistUser();
}, { immediate: true });





</script>

<style scoped>

:deep() .v-table .v-table__wrapper > table > thead > tr > th:not(:last-child) {
    border-right: thin solid rgba(var(--v-border-color), var(--v-border-opacity));
  }
  :deep() .v-table .v-table__wrapper > table > tbody > tr > td:not(:last-child), .v-table .v-table__wrapper > table > tbody > tr > th:not(:last-child) { 
    border-right: thin solid rgba(var(--v-border-color), var(--v-border-opacity));
  }



</style>
